import * as React from "react"

type LeafIconProps = React.SVGProps<SVGSVGElement> & {
  size?: number
}

export default function LeafIcon({ size = 24, className, ...props }: LeafIconProps) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 43 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M28.1435 14.4929C28.1435 8.89286 25.4918 3.11429 21.5 0C17.501 3.11429 14.8565 8.89286 14.8565 14.4929C9.03 10.1929 5.51833 9.39286 0 9.09286C1.9135 30.1071 21.5 30 21.5 30C21.5 30 41.0865 30.1 43 9.09286C37.4817 9.39286 33.97 10.1929 28.1435 14.4929Z"
        fill="currentColor"
      />
    </svg>
  )
}